import purchaseRouter from "./purchaseRouter";
import stockRouter from "./stockRouter";
import shipmentRouter from "./shipmentRouter";

/**
 * 統整所有 clubInventory 路由
 * 將所有子路由模組合併成一個陣列
 */
const inventorySubRouter = [
	...purchaseRouter,
	...stockRouter,
	...shipmentRouter,
];

export default inventorySubRouter;
